import { useState } from 'react';
import { saveAuthData } from '@/core/auth';
import { useSession } from '@/store/session';
import { authApi } from './api';

type Profile = { fullName?: string; phone?: string; birthDate?: string };

export function useFirebaseAuthLogin() {
  const { setSession } = useSession();
  const [isLoading, setIsLoading] = useState(false);

  const completeLogin = async (idToken: string, profile?: Profile) => {
    setIsLoading(true);
    try {
      const token = await authApi.firebaseLogin(idToken, profile);
      sessionStorage.setItem('auth_token', token);
      const user = await authApi.me();
      saveAuthData(token, user);
      setSession(token, user);
      return user;
    } finally {
      setIsLoading(false);
    }
  };

  return { completeLogin, isLoading };
}
